// extracted by mini-css-extract-plugin
export default {"cardContainer":"outage-cover_cardContainer__4sfVc"};